var render, staticRenderFns
import script from "./ProfileBody.vue?vue&type=script&lang=js&"
export * from "./ProfileBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb67db0",
  null
  
)

export default component.exports